import { Component, forwardRef, Inject } from '@angular/core';
import { BlockUI, NgBlockUI }            from 'ng-block-ui';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                        from '@angular/forms';
import { TranslateService }              from '@ngx-translate/core';

import { MessagesService }  from '../messages/messages.service';
import { StockTakeItem }    from './typings/stock-take.item';
import { StockTakeService } from './stock-take.service';
import { ProductService } from '../products/product.service';

@Component({
  selector   : 'wor-stock-take-quick-add',
  template: require('./stock-take.quick-add.component.html')
})
export class StockTakeQuickAddComponent {
  @BlockUI('stockTakeQuickAddBlock') block : NgBlockUI;

  itemCode: string;
  quantity: number;
  searched: boolean;

  product = {} as StockTakeItem;

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => ProductService)) private productService  : ProductService,
    @Inject(forwardRef(() => StockTakeService))
    private stockTakeService: StockTakeService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  find () : void {
    if ( this.itemCode ) {
      this.block.start();

      this.searched = true;

      this.stockTakeService.findProduct(this.itemCode)
      .then(product => {
        this.product = this.productService.formatSearchableTags(product);
      })
      .catch(err => {
        this.messagesService.error(err);
      })
      .finally(() => this.block.stop());
    }
    else {
      this.product = {} as StockTakeItem;
    }
  }

  save ( form : NgForm ) : void {
    this.block.start();

    this.stockTakeService.addProduct({
      draft_quantity: this.quantity,
      id            : '',
      product_id    : this.product.id
    })
    .then(() => {
      this.messagesService.show(this.translateService.instant('STOCKTAKE_SPACE.PRODUCT_ADDED_TO_STOCKTAKE', {
        item_code: this.itemCode
      }), 'success');

      this.itemCode = '';
      this.product  = {} as StockTakeItem;;
      this.quantity = 0;
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => this.block.stop());
  }
}
